(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    

  /**
   *  Aggiorna i campi nascosti degli attributi del carrello in base ai dati dell'elemento di riferimento (collezione o prodotto)
   */

  window.updateCollectionProp = () => {


      const refElement = document.getElementById('collection-reference');
      const hiddenDate = document.getElementById('CollectionDeliveryDateSelected');
      const hiddenPayment = document.getElementById('CollectionPaymentTerm');
      const hiddenDraftOrder = document.getElementById('CollectionDraftOrder');

      if (!refElement) return;

      const fields = {
          "handle": refElement.dataset.handle || null,
          "name": refElement.dataset.name || null,
          "id": refElement.dataset.id || null,
          "deliveryDate": hiddenDate.value || null,
          "paymentTerm": hiddenPayment?.value || null,
          "enableDraftOrder": hiddenDraftOrder?.value || null,
      };

      const noteInput = document.querySelector('#cart input[name="note"]');
      const collectionReferenceName = document.querySelector('#CollectionReferenceName');
      // const collectionDeliveryDateStart = document.querySelector('#CollectionDeliveryDateStart');
      // const collectionDeliveryDateEnd = document.querySelector('#CollectionDeliveryDateEnd');
      
      // Eseguiamo il controllo dei requisiti checkout ad ogni ciclo del setInterval
      window.validateCartRequirements();

      if (!noteInput || !collectionReferenceName) return;
      
      noteInput.value = JSON.stringify(fields);
      collectionReferenceName.value = JSON.stringify(refElement.dataset.name);
      // collectionDeliveryDateStart.value = JSON.stringify(refElement.dataset.deliveryStart);
      // collectionDeliveryDateEnd.value = JSON.stringify(refElement.dataset.deliveryEnd);

  };

  // Funzione di validazione separata
  window.validateCartRequirements = () => {
      const checkoutBtn = document.getElementById('checkout');
      
      // Selettori visibili
      const dateInput = document.getElementById('delivery-date');
      const paymentSelect = document.getElementById('payment-terms');
      const draftOrderToggle = document.getElementById('draft-order-toggle');
      
      // Input hidden per Shopify Attributes
      const hiddenDate = document.getElementById('CollectionDeliveryDateSelected');
      const hiddenPayment = document.getElementById('CollectionPaymentTerm');
      const hiddenDraftOrder = document.getElementById('CollectionDraftOrder');

      if (!checkoutBtn || !dateInput ) return;

      // 1. Trasferimento valori ai campi hidden
      if (hiddenDate) hiddenDate.value = dateInput.value;
      if (hiddenDraftOrder) hiddenDraftOrder.value = draftOrderToggle?.checked || false;

      if (paymentSelect) {
          if (hiddenPayment) hiddenPayment.value = paymentSelect.value;
          // 2. Logica di attivazione bottone
          if (dateInput.value !== "" && paymentSelect.value !== "") {
              checkoutBtn.disabled = false;
              checkoutBtn.classList.remove('disabled');
          } else {
              checkoutBtn.disabled = true;
              checkoutBtn.classList.add('disabled');
          }
      } else {
          if (dateInput.value !== "") {
              checkoutBtn.disabled = false;
              checkoutBtn.classList.remove('disabled');
          } else {
              checkoutBtn.disabled = true;
              checkoutBtn.classList.add('disabled');
          }
      }

  };

  // Listener globale per i cambiamenti (già presente nel tuo codice)
  document.addEventListener("change", (e) => {
      if (e.target.id === 'delivery-date' || e.target.id === 'payment-terms' || e.target.id === 'draft-order-toggle') {
          window.validateCartRequirements();
          window.updateCollectionProp();
      }
  });

  // Gestione del form di checkout per includere il codice sconto
  (function () {
      document.addEventListener('click', async function (event) {
          // Cerco se il click è partito da (o dentro) il bottone #checkout
          const checkoutButton = event.target.closest('#checkout');
          if (!checkoutButton) return; // click su altro, esco

          event.preventDefault();
          event.stopPropagation();

          // Trovo il form del drawer ogni volta (può essere stato ricreato)
          const cartForm = document.getElementById('cart');
          if (!cartForm) {
          console.warn('[CartDiscount] cart non trovato');
          }

          // Leggo il codice sconto dall'input (può stare nel drawer o altrove)
          const discountInput = document.getElementById('discount-input');
          const rawValue = discountInput ? discountInput.value : '';
          const discountCode = (rawValue || '').trim();

          console.log('[CartDiscount] Discount:', '"' + discountCode + '"');

          // 1) Se ho il form, aggiorno il carrello (note, attributes, qty, ecc.)
          if (cartForm) {
              const formData = new FormData(cartForm);

              try {
                  const response = await fetch('/cart', {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                  });

                  if (!response.ok) {
                  console.error('[CartDiscount] Errore /cart:', response.status, response.statusText);
                  // puoi decidere di continuare comunque
                  }
              } catch (error) {
                  console.error('[CartDiscount] Errore fetch /cart:', error);
                  // idem, puoi decidere di continuare comunque
              }
          }

          // 2) Costruisco URL di checkout
          let checkoutLink = '/checkout';

          if (discountCode !== '') {
            checkoutLink = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout';
          }

          sessionStorage.setItem('pending_checkout', 'true');

          window.location.href = checkoutLink;
      });
  })();

  window.addEventListener('pageshow', (event) => {
    const isBackNavigation = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    const wasInCheckout = sessionStorage.getItem('pending_checkout');

    // event.persisted è true se la pagina è caricata dalla BFCache (molto comune su Safari/Mobile)
    if ((isBackNavigation || event.persisted) && wasInCheckout === 'true') {
      
      console.log("Bentornato dal Checkout! Aggiorno i dati...");

      // 1. Rimuovi subito il flag per evitare che ricarichi all'infinito se l'utente preme F5
      sessionStorage.removeItem('pending_checkout');

      // 2. Logica di ricaricamento
      aggiornaDatiCarrello();
    }
  });

  function aggiornaDatiCarrello() {
    // Ricarica la pagina per pulire lo stato
    location.reload();
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-bulk"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const form = document.querySelector('[data-bulk-add-form]');
    if (!form) return;

    const dialog = document.querySelector('[data-bulk-add-dialog]');
    const messageEl = dialog && dialog.querySelector('[data-bulk-add-message]');

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      const quantityInputs = form.querySelectorAll('[data-variant-quantity-input]');
      const items = [];

      quantityInputs.forEach(function(input) {
        const quantity = parseInt(input.value, 10);
        if (!quantity || quantity <= 0) return;
        const row = input.closest('[data-variant-row]');
        if (!row) return;
        const variantId = row.getAttribute('data-variant-id');
        if (!variantId) return;
        items.push({ id: Number(variantId), quantity: quantity });
      });

      if (!items.length) {
        if (dialog && messageEl) {
          messageEl.textContent = form.dataset.emptyMessage || '';
          dialog.showModal();
        }
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(function() {
          quantityInputs.forEach(function(input) {
            input.value = '';
          });

          const openDialog = function() {
            if (dialog && messageEl) {
              messageEl.textContent = form.dataset.successMessage || '';
              dialog.showModal();
            }
          };

          if (document.startViewTransition) {
            document.startViewTransition(openDialog);
          } else {
            openDialog();
          }

          document.dispatchEvent(
            new CustomEvent('cart:bulk-items-added', { detail: { items: items } })
          );
        })
        .catch(function(error) {
          if (dialog && messageEl) {
            messageEl.textContent = form.dataset.errorMessage || '';
            dialog.showModal();
          }
          console.error(error);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-infinite"]) return;
  try {
    
  if (!customElements.get('infinite-scroll')) {
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.totalPages = parseInt(this.dataset.totalPages || '1', 10);
        this.currentPage = parseInt(this.dataset.currentPage || '1', 10);
        this.loading = false;
        this.sentinel = this.querySelector('[data-infinite-sentinel]');
        this.spinner = this.querySelector('[data-infinite-spinner]');
        if (!this.sentinel || this.currentPage >= this.totalPages) return;
        // 1) IntersectionObserver: efficiente, carica quando il sentinel si avvicina.
        this.observer = new IntersectionObserver(
          (entries) => { if (entries[0] && entries[0].isIntersecting) this.loadNext(); },
          { rootMargin: '600px' }
        );
        this.observer.observe(this.sentinel);
        // 2) Fallback su scroll/resize: su alcuni primi caricamenti l'observer può non
        //    scattare (timing di upgrade/layout) -> qui garantisco comunque il caricamento.
        this._ticking = false;
        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          requestAnimationFrame(() => { this._ticking = false; this.maybeLoad(); });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        // 3) Auto-fill: se la prima pagina non riempie lo schermo, continua a caricare.
        this.maybeLoad();
        window.addEventListener('load', () => this.maybeLoad());
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this._onScroll) {
          window.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onScroll);
        }
      }
      // Carica la pagina successiva se il sentinel è entro ~600px dal fondo del viewport.
      maybeLoad() {
        if (this.loading || this.currentPage >= this.totalPages || !this.sentinel) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (this.sentinel.getBoundingClientRect().top <= vh + 600) this.loadNext();
      }
      async loadNext() {
        if (this.loading || this.currentPage >= this.totalPages) return;
        this.loading = true;
        if (this.spinner) this.spinner.hidden = false;
        try {
          const nextPage = this.currentPage + 1;
          const params = new URLSearchParams(window.location.search);
          params.set('page', String(nextPage));
          params.set('section_id', this.sectionId);
          const res = await fetch(window.location.pathname + '?' + params.toString());
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const newGrid = doc.getElementById('product-grid');
          const liveGrid = document.getElementById('product-grid');
          if (newGrid && liveGrid) {
            const frag = document.createDocumentFragment();
            Array.from(newGrid.children).forEach((c) => frag.appendChild(c));
            liveGrid.appendChild(frag);
            document.dispatchEvent(new CustomEvent('infinite-scroll:appended', { bubbles: true }));
          }
          this.currentPage = nextPage;
        } catch (e) {
          console.error('[infinite-scroll]', e);
        } finally {
          this.loading = false;
          if (this.spinner) this.spinner.hidden = true;
          if (this.currentPage >= this.totalPages) {
            if (this.observer) this.observer.disconnect();
          } else if (this.observer && this.sentinel) {
            this.observer.unobserve(this.sentinel);
            this.observer.observe(this.sentinel);
            // Se dopo l'append lo schermo non è ancora pieno, continua (auto-fill).
            this.maybeLoad();
          }
        }
      }

      async loadAll() {
        // Carica TUTTE le pagine restanti in sequenza: serve alla search per filtrare l'intera
        // collezione (non usiamo paginazione). Idempotente: se già completo esce subito; chiamate
        // concorrenti si auto-fermano (loadNext esce se già in loading -> nessun avanzamento).
        let guard = 0;
        while (this.currentPage < this.totalPages && guard < 200) {
          const before = this.currentPage;
          await this.loadNext();
          if (this.currentPage === before) break;
          guard++;
        }
      }
    }
    customElements.define('infinite-scroll', InfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-customer-change"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    try {
      var params = new URLSearchParams(window.location.search);
      var emailFromUrl = params.get('email') || params.get('login_hint');
      var emailContainer = document.getElementById('customer-change-email');
      var link = document.getElementById('customer-change-link');
      var copyButton = document.getElementById('customer-change-copy');

      if (!emailFromUrl || !emailContainer || !link) {
        if (link) {
          link.style.display = 'none';
        }
        if (copyButton) {
          copyButton.style.display = 'none';
        }
        return;
      }

      emailContainer.textContent = emailFromUrl;

      if (copyButton && navigator.clipboard && navigator.clipboard.writeText) {
        var initialLabel = copyButton.textContent;
        var successLabel = copyButton.getAttribute('data-label-success') || initialLabel;

        copyButton.addEventListener('click', function () {
          navigator.clipboard
            .writeText(emailFromUrl)
            .then(function () {
              copyButton.classList.add('customer-change__copy-button--success');
              copyButton.textContent = successLabel;
              window.setTimeout(function () {
                copyButton.classList.remove('customer-change__copy-button--success');
                copyButton.textContent = initialLabel;
              }, 2000);
            })
            .catch(function (error) {
              console.error('Errore nella copia della mail:', error);
            });
        });
      } else if (copyButton) {
        copyButton.style.display = 'none';
      }

      if (link) {
        var logoutUrl = link.getAttribute('data-logout-url');
        var loginUrl = link.getAttribute('data-login-url');

        link.addEventListener('click', function (event) {
          if (!logoutUrl || !loginUrl) {
            return;
          }

          event.preventDefault();

          try {
            fetch(logoutUrl, {
              method: 'GET',
              credentials: 'include'
            })['finally'](function () {
              window.location.href = loginUrl;
            });
          } catch (error) {
            window.location.href = loginUrl;
          }
        });
      }
    } catch (e) {
      console.error('Errore nello script customer-change:', e);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications-boots-v2"] && !Shopify.designMode) return;
  try {
    

 let selectors = {
  specPins: ".section-specifications__features .spec_pin",
  specInfos: ".section-specifications__info",
 }

 let specPins = document.querySelectorAll(selectors.specPins)
 let specInfos = document.querySelectorAll(selectors.specInfos)

 if (specPins && specInfos) {
   specPins.forEach(specPin => {
    specPin.addEventListener("click", () => {
      let featureSelected = specPin.getAttribute("attr-spec")
      specInfos.forEach(specInfo => {
        specInfo.classList.add("hide")
  
        let featureSelectedAttr = specInfo.getAttribute("attr-spec")
        if ( featureSelectedAttr == featureSelected) {
          specInfo.classList.remove("hide")
        }
      })
  
      specPins.forEach(sp => {
        sp.classList.remove("selected")
      })

      specPin.classList.add("selected")
  
    })
   });
 }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications"] && !Shopify.designMode) return;
  try {
    

 let selectors = {
  specPins: ".section-specifications__features .spec_pin",
  specInfos: ".section-specifications__info",
 }

 let specPins = document.querySelectorAll(selectors.specPins)
 let specInfos = document.querySelectorAll(selectors.specInfos)

 if (specPins && specInfos) {
   specPins.forEach(specPin => {
    specPin.addEventListener("click", () => {
      let featureSelected = specPin.getAttribute("attr-spec")
      specInfos.forEach(specInfo => {
        specInfo.classList.add("hide")
  
        let featureSelectedAttr = specInfo.getAttribute("attr-spec")
        if ( featureSelectedAttr == featureSelected) {
          specInfo.classList.remove("hide")
        }
      })
  
      specPins.forEach(sp => {
        sp.classList.remove("selected")
      })

      specPin.classList.add("selected")
  
    })
   });
 }


  } catch(e) { console.error(e); }
})();
})();
